// extracted by mini-css-extract-plugin
export default {"dark":"App_dark__TE4we","light":"App_light__-Dwrv"};